<template>
  <div class="popular-combos">
    <h3>Popular Combos</h3>

    <Swiper :options="swiperOption">
      <SwiperSlide
        v-for="(combo, index) in combos"
        :key="index"
        :class="isWeb ? 'swiper-no-swiping swiper-web' : ''"
      >
        <div class="popular-combos-card">
          <ul class="popular-combos-list">
            <li
              v-for="(selection, i) in combo.selections"
              :key="i"
            >
              <p>{{ selection.outcomes[0].description }}</p>
              <span>{{ selection.description }}</span>
              <i v-if="i !== combo.selections.length - 1" />
            </li>
          </ul>
          <PopularOdds
            :event="event"
            :selections="combo.selections"
            :odds="combo.odds"
            :selection-list="selectionList"
            @select="addSelections(index)"
          />
        </div>
      </SwiperSlide>

      <template
        v-if="isWeb"
        #button-prev
      >
        <div class="button-prev-box">
          <div class="button-prev btn">
            <svg-icon icon-class="icon-arrowright-new" />
          </div>
          <div class="btn-bg" />
        </div>
      </template>
      <template
        v-if="isWeb"
        #button-next
      >
        <div class="button-next-box">
          <div class="button-next btn">
            <svg-icon icon-class="icon-arrowright-new" />
          </div>
          <div class="btn-bg" />
        </div>
      </template>
    </Swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-slim-swiper'
import PopularOdds from './PopularOdds.vue'
import 'base/icons/svg/arrowright-new.svg'

export default {
  name: 'PopularCombos',
  components: {
    Swiper,
    SwiperSlide,
    PopularOdds
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    combos: {
      type: Array,
      default: () => []
    },
    toggle: {
      type: Function,
      default: null
    },
    selectionList: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    let swiperOption = {}

    const swiperOptionWap = {
      slidesPerView: 'auto',
      spaceBetween: 6,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 0,
      freeMode: {
        enabled: true,
        sticky: true,
        momentumRatio: 0.5,
        momentumVelocityRatio: 0.8
      }
    }

    const swiperOptionWeb = {
      slidesPerView: 'auto',
      spaceBetween: 6,
      slidesOffsetAfter: 0,
      navigation: {
        nextEl: '.button-next',
        prevEl: '.button-prev'
      }
    }

    const isWeb = process.env.PLATFORM === 'desktop'

    if (isWeb) {
      swiperOption = swiperOptionWeb
    } else {
      swiperOption = swiperOptionWap
    }

    const addSelections = (index) => {
      const active = props.toggle({
        event: props.event,
        combos: props.combos[index]
      })
      return active
    }

    return {
      swiperOption,
      addSelections,
      isWeb
    }
  }
}
</script>

<style lang="scss" scoped>
.popular-combos {
  margin-bottom: 16px;

  h3 {
    height: 48px;
    padding-left: 16px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 48px;
  }

  .swiper-slide {
    width: 320px;
    height: 178px;
  }

  &-card {
    display: flex;
    width: 320px;
    height: 178px;
    box-sizing: border-box;
    padding: 11px 20px 11px 38px;
    border: 1px solid rgba(255, 202, 39, 5%);
    border-radius: 12px;
    background: #222;
  }

  &-list {
    flex: 1;

    li {
      position: relative;
      display: block;
      padding: 9px 0;
      color: #999;
      font-size: 12px;
      line-height: 14px;

      &::after {
        position: absolute;
        top: 50%;
        left: -16px;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #ffca27;
        content: "";
        transform: translateY(-50%);
      }

      &::before {
        position: absolute;
        top: 50%;
        left: -18px;
        width: 7px;
        height: 7px;
        border: 1px solid #ffca27;
        border-radius: 50%;
        content: "";
        filter: blur(1px);
        opacity: 0.6;
        transform: translateY(-50%);
      }

      i {
        position: absolute;
        top: 50%;
        left: -14.5px;
        width: 0;
        height: 41px;
        border-left: 1px solid #ffca27;
        margin-top: 5px;
      }

      p {
        height: 16px;
        margin-bottom: 4px;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
      }
    }
  }

  .button-prev-box,
  .button-next-box {
    display: none;

    .btn-bg {
      position: absolute;
      z-index: 100;
      top: 0;
      width: 84px;
      height: 100%;
      background-image: linear-gradient(270deg, rgba(20, 21, 28, 3%) 0%, rgba(0, 0, 0, 70%) 100%);
    }
  }

  .button-next-box {
    .btn-bg {
      right: 0;
      background-image: linear-gradient(270deg, rgba(0, 0, 0, 70%) 0%, rgba(20, 21, 28, 3%) 100%);
    }
  }

  .btn {
    position: absolute;
    z-index: 999;
    top: 71px;
    display: flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #333;
    cursor: pointer;
    line-height: 36px;
    text-align: center;
  }

  .button-prev {
    left: 10px;

    .icon-arrowright-new {
      transform: rotate(180deg);
    }
  }

  .button-next {
    right: 10px;
  }

  &:hover {
    .button-prev-box,
    .button-next-box {
      display: block;
    }
  }

  .swiper-button-disabled {
    display: none !important;

    + .btn-bg {
      display: none !important;
    }
  }
}

[data-mode="light"] .popular-combos {
  h3 { color: #000; }
  .popular-combos-list li { color: #666; }
  .popular-combos-list li p { color: #000; }

  .popular-combos-card {
    border: 1px solid rgba(255, 202, 39, 5%);
    background: #fff;
  }

  .popular-combos-odds {
    background:  #f7f7f7;
    color: #000;

    &.active {
      background-color: #ffca27;
      color: #333;
    }
  }
}
</style>
